const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:5001/api';

class ApiService {
  constructor() {
    this.baseURL = API_BASE_URL;
  }

  async request(endpoint, options = {}) {
    const url = `${this.baseURL}${endpoint}`;

    // Get JWT token from localStorage (set by TokenGuard from URL param)
    const token = localStorage.getItem('token');

    const config = {
      headers: {
        'Content-Type': 'application/json',
        ...(token && { 'Authorization': `Bearer ${token}` }),
        ...options.headers,
      },
      ...options,
    };

    try {
      const response = await fetch(url, config);
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      return await response.json();
    } catch (error) {
      console.error('API request failed:', error);
      throw error;
    }
  }

  // Clinical Outcomes
  async getClinicalOutcomes(params = {}) {
    const queryString = new URLSearchParams(params).toString();
    return this.request(`/clinical-outcomes/trajectory?${queryString}`);
  }

  async getClientProgress(clientId, params = {}) {
    const queryString = new URLSearchParams(params).toString();
    return this.request(`/clinical-outcomes/client-progress/${clientId}?${queryString}`);
  }

  // Provider Productivity
  async getProviderProductivity(params = {}) {
    const queryString = new URLSearchParams(params).toString();
    return this.request(`/providers/productivity?${queryString}`);
  }

  async getProviderPerformance(therapistId, params = {}) {
    const queryString = new URLSearchParams(params).toString();
    return this.request(`/providers/performance/${therapistId}?${queryString}`);
  }

  async getSessionVolume(params = {}) {
    const queryString = new URLSearchParams(params).toString();
    return this.request(`/providers/session-volume?${queryString}`);
  }

  // Demographics
  async getDemographics(params = {}) {
    const queryString = new URLSearchParams(params).toString();
    return this.request(`/demographics?${queryString}`);
  }

  async getDemographicsSummary(params = {}) {
    const queryString = new URLSearchParams(params).toString();
    return this.request(`/demographics/summary?${queryString}`);
  }

  // Funding
  async getFundingSources(params = {}) {
    const queryString = new URLSearchParams(params).toString();
    return this.request(`/funding/sources?${queryString}`);
  }

  async getInsuranceUtilization(params = {}) {
    const queryString = new URLSearchParams(params).toString();
    return this.request(`/funding/insurance-utilization?${queryString}`);
  }

  async getClaimsData(params = {}) {
    const queryString = new URLSearchParams(params).toString();
    return this.request(`/funding/claims?${queryString}`);
  }

  async getClaimsAnalysis(params = {}) {
    const queryString = new URLSearchParams(params).toString();
    return this.request(`/funding/claims-analysis?${queryString}`);
  }

  // Engagement
  async getEngagementMetrics(params = {}) {
    const queryString = new URLSearchParams(params).toString();
    return this.request(`/engagement/metrics?${queryString}`);
  }

  async getEngagementTrends(params = {}) {
    const queryString = new URLSearchParams(params).toString();
    return this.request(`/engagement/trends?${queryString}`);
  }

  async getClientRetention(params = {}) {
    const queryString = new URLSearchParams(params).toString();
    return this.request(`/engagement/retention?${queryString}`);
  }

  async getAttendanceAnalysis(params = {}) {
    const queryString = new URLSearchParams(params).toString();
    return this.request(`/engagement/metrics?${queryString}`);
  }

  // Therapists
  async getTherapists(params = {}) {
    const queryString = new URLSearchParams(params).toString();
    return this.request(`/therapists?${queryString}`);
  }

  // Health check
  async getHealth() {
    return this.request('/health');
  }
}

const apiService = new ApiService();
export default apiService; 